import React from "react";

export const BankLegalCheck: React.FC = () => {

    return (
        <>Mediante el “check” de esta orden de domiciliación, el titular de la cuenta autoriza al C. Actex a enviar instrucciones a su entidad bancaria para adeudar en su cuenta el pago que corresponda por los servicios solicitados por Ud. y de los que es beneficiario. Como parte de sus derechos, el deudor está legitimado al reembolso por su entidad en los términos y condiciones del contrato que tenga suscrito con la misma. La solicitud de reembolso deberá efectuarse dentro de las ocho semanas que siguen a la fecha de su adeudo en cuenta. Puede obtener más información adicional sobre sus derechos en su entidad bancaria.</>
    )

}